import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_table = _resolveComponent("app-table")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    title: _ctx.type ? '关联订单' : '已选充电/占位费订单',
    width: "900",
    placement: "right",
    visible: _ctx.visible,
    onClose: _ctx.onClose
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_tabs, {
        activeKey: _ctx.activeKey,
        "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeKey) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_tab_pane, {
            key: "1",
            tab: "充电订单"
          }, {
            default: _withCtx(() => [
              (_ctx.activeKey === '1')
                ? (_openBlock(), _createBlock(_component_app_table, {
                    key: 0,
                    ref: "tableRef",
                    size: "default",
                    "row-key": "orderNo",
                    columns: _ctx.tableColumns,
                    data: _ctx.loadTableData,
                    scroll: { x: true }
                  }, null, 8, ["columns", "data"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_a_tab_pane, {
            key: "2",
            tab: "占位费订单"
          }, {
            default: _withCtx(() => [
              (_ctx.activeKey === '2')
                ? (_openBlock(), _createBlock(_component_app_table, {
                    key: 0,
                    ref: "tableRef1",
                    size: "default",
                    "row-key": "orderNo",
                    columns: _ctx.tableColumns1,
                    data: _ctx.loadTableData,
                    scroll: { x: true }
                  }, null, 8, ["columns", "data"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["activeKey"])
    ]),
    _: 1
  }, 8, ["title", "visible", "onClose"]))
}